module.exports = __webpack_public_path__ + "img/question.4e16e805.png";